export class Gleba {
    Id: number;
    EmpresaId: number;
    AreaId: number;
    Descricao:string = "";
    AreaTotal: number = 0;
}
